// extracted by mini-css-extract-plugin
module.exports = {"BackgroundImage":"_2F4oau3NkkHCRLJGmNbGXl"};